import {defineNuxtRouteMiddleware, useNuxtApp} from '#app';
import {useGuestHost, useAuth} from '#imports';
import {safelyNavigateTo} from '@malt/utils';

export default defineNuxtRouteMiddleware(async () => {
    const nuxtApp = useNuxtApp();
    const {loggedIn, currentIdentityIsClient, currentIdentityIsFreelance, currentIdentityIsSubcontractor} = useAuth(nuxtApp.$pinia);
    const host = useGuestHost();

    if (!loggedIn) {
        return;
    }

    let path = '/account/membership';
    if (currentIdentityIsClient) {
        path = '/project-client/find-freelancers';
    } else if (currentIdentityIsFreelance) {
        path = '/dashboard/freelancer';
    } else if (currentIdentityIsSubcontractor) {
        path = '/freelancer/company';
    }

    return await safelyNavigateTo(`${host}${path}`, {replace: true, externalToThisApp: true});
});
